/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1AccountingmappingsQueryResponse } from '../../types/GetV1Accountingmappings.ts'

export const getV1AccountingmappingsQueryKey = () => [{ url: '/v1/AccountingMappings' }] as const

export type GetV1AccountingmappingsQueryKey = ReturnType<typeof getV1AccountingmappingsQueryKey>

/**
 * {@link /v1/AccountingMappings}
 */
export async function getV1Accountingmappings(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1AccountingmappingsQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/AccountingMappings`, ...requestConfig })
    return res
}

export function getV1AccountingmappingsQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1AccountingmappingsQueryKey()
    return queryOptions<
        ResponseConfig<GetV1AccountingmappingsQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1AccountingmappingsQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Accountingmappings(config)
        },
    })
}

/**
 * {@link /v1/AccountingMappings}
 */
export function useGetV1Accountingmappings<
    TData = ResponseConfig<GetV1AccountingmappingsQueryResponse>,
    TQueryData = ResponseConfig<GetV1AccountingmappingsQueryResponse>,
    TQueryKey extends QueryKey = GetV1AccountingmappingsQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1AccountingmappingsQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1AccountingmappingsQueryKey()

    const query = useQuery(
        {
            ...getV1AccountingmappingsQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
